if (!customElements.get('site-footer')) {
  customElements.define(
    'site-footer',
    class SiteFooter extends HTMLElement {
      connectedCallback() {
        this.setNodeSelectors();
        this.setEventListeners();
      }

      /**
       * Sets node selectors.
       */
      setNodeSelectors() {
        this.nodeSelectors = {
          columnHeadings: this.querySelectorAll('[js-site-footer="columnHeading"]'),
        };
      }

      /**
       * Sets event listeners.
       */
      setEventListeners() {
        this.nodeSelectors.columnHeadings.forEach((element) => {
          element.addEventListener('click', (event) => this.handleColumnHeadingEvent(event));
        });
      }

      /**
       * Returns the menu for the given heading element.
       * @param {HTMLElement} heading - The heading element.
       * @returns {HTMLElement}
       */
      getHeadingMenu(heading) {
        return heading.parentElement.querySelector('[js-site-footer="columnMenu"]');
      }

      /**
       * Handles the column heading click event.
       * @param {Event} event - The event payload.
       */
      handleColumnHeadingEvent(event) {
        const menu = this.getHeadingMenu(event.currentTarget);
        const breakpoints = getBreakpoints();
        const isLarge = window.matchMedia(`(min-width: ${breakpoints.large}px)`).matches;

        if (isLarge) {
          return;
        }

        if (menu.classList.contains('is-active')) {
          menu.classList.remove('is-active');
          return;
        }

        menu.classList.add('is-active');
      }
    }
  );
}
